<template>
  <div class="asc-header--container">
    <div class="asc-header--content">
      <div class="asc-header--content-left">
        <asc-label
          size="md"
          class="asc-header--label-bold"
          :value="getName"
        ></asc-label>
      </div>
      <div class="asc-header--content-middle">
        <asc-label
          size="md"
          class="asc-header--hex-code"
          :value="getHexCode"
        ></asc-label>
      </div>
      <div class="asc-header--content-count">
        <asc-gray-label-box
          class="asc-medium-label-box"
          :value="getCount"
        ></asc-gray-label-box>
      </div>
    </div>
  </div>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'
import AscGrayLabelBox from '@/components/atoms/AscGrayLabelBox'

export default {
  name: 'AscFaultMonitorItemHeader',

  components: { AscLabel, AscGrayLabelBox },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    getName() {
      return this.item ? this.item.name : ''
    },
    getHexCode() {
      return this.item ? this.item.hexCode : ''
    },
    getCount() {
      return this.item ? this.item.count.toString() : '0'
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-header--container {
  display: flex;
  width: 100%;

  .asc-header--content {
    display: flex;
    width: 100%;

    .asc-header--content-left {
      flex: 0 0 30%;
      width: auto;

      .asc-header--label-bold {
        font-weight: bold;
      }
    }

    .asc-header--content-middle {
      flex: 1;
      margin-left: 8px;

      .asc-header--hex-code {
        color: $gray-700;
      }
    }

    .asc-header--content-count {
      max-width: 32px;
      justify-content: flex-end;
    }
  }
}
</style>
